// extracted by mini-css-extract-plugin
export var header = "_s8-1";
export var maskBottom = "_s8-6";
export var maskMiddle = "_s8-7";
export var maskTop = "_s8-5";
export var root = "_s8-0";
export var scrollDownButton = "_s8-3";
export var scrollDownButtonHidden = "_s8-4";
export var viewport = "_s8-2";